// Recherche du chat : insensible aux accents et a la casse.
export function normalizeSearchText(value: string): string {
  return value.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
}

// Positions d'une recherche dans un texte, exprimees dans le texte d'origine :
// la normalisation retire les accents et decale donc les index, d'ou la table
// de correspondance caractere normalise -> caractere d'origine.
export function findSearchRanges(text: string, query: string): Array<[number, number]> {
  const normalizedQuery = normalizeSearchText(query)
  if (!normalizedQuery) return []

  let normalized = ''
  const origins: number[] = []
  for (let index = 0; index < text.length; index++) {
    const normalizedChar = normalizeSearchText(text[index])
    for (const char of normalizedChar) {
      normalized += char
      origins.push(index)
    }
  }

  const ranges: Array<[number, number]> = []
  let from = normalized.indexOf(normalizedQuery)
  while (from !== -1) {
    const end = from + normalizedQuery.length
    ranges.push([origins[from], origins[end - 1] + 1])
    from = normalized.indexOf(normalizedQuery, end)
  }
  return ranges
}
